export function buildHideActionsBranchProps(vm, props, morphBubble) {
  const { reactions, bubbleAlign, onReaction, showEditAction, onEdit } = props
  return {
    bubbleWithReactionsClassName: vm.bubbleWithReactionsClassName,
    bubbleAnchorRef: vm.bubbleAnchorRef,
    bubbleAnchorClassName: vm.bubbleAnchorClassName,
    bubbleZoneEnter: vm.hover.bubbleZoneEnter,
    bubbleZoneLeave: vm.hover.bubbleZoneLeave,
    morphBubble,
    reactions,
    bubbleAlign,
    onReaction,
    reactionPickerAnchorEl: vm.reactionPickerAnchorEl,
    setReactionPickerAnchorEl: vm.setReactionPickerAnchorEl,
    setMoreMenuAnchor: vm.setMoreMenuAnchor,
    showFloatingToolbar: vm.showFloatingToolbar,
    toolbarPlacement: vm.toolbarPlacement,
    floatingToolbarEnter: vm.hover.floatingToolbarEnter,
    floatingToolbarLeave: vm.hover.floatingToolbarLeave,
    handleReaction: vm.handleReaction,
    showEditAction,
    onEdit,
    moreMenuAnchor: vm.moreMenuAnchor,
    moreActionsMenuItems: vm.menu.moreActionsMenuItems,
    handleMoreMenuItemSelect: vm.menu.handleMoreMenuItemSelect,
  }
}
